/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Rule_Keywords_RequiredInputs */

const vi_expense_rule_keywords_required = /** @type {(inputs: Expense_Rule_Keywords_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm ít nhất một từ khoá`)
};

/**

* @param {Expense_Rule_Keywords_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_rule_keywords_required = /** @type {((inputs?: Expense_Rule_Keywords_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Rule_Keywords_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_rule_keywords_required(inputs)
});